<template>
<div>
    <b-card header="featured" header-tag="header">
        <template v-slot:header>
            <h5 class="mb-0"><i class="fas fa-boxes" /> Produtos</h5>
        </template>
        <div class="card-body">
            <div class="row">
                <div class="col-md-4">
                    <search-input :alias="'Produto'" v-model="form.id.value" :displayedValue="form.description.value" :form="form" :name="'id'" @search="searchProduct($event)" :searchResult="searchProductResults" :ref="'searchProductInput'" @selected="setProductValue($event)">
                        <search-input-option v-for="(row, index) in searchProductResults.data" tabindex="0" :key="index" :index="index" @click="setProductValue(row)">
                            <div>
                                {{ row.description }}
                                <br />
                                <small class="text-muted">{{ row.price | decimal }}</small>
                                <br />
                                <br />
                            </div>
                        </search-input-option>
                    </search-input>
                </div>

                <div class="col-md-2">
                    <text-input v-model="form.unit.value" :alias="'Unidade'"></text-input>
                </div>
                <div class="col-md-2">
                    <number-input v-model="form.quantity.value" :alias="'Quantidade'"></number-input>
                </div>
                <div class="col-md-2">
                    <number-input v-model="form.quantity.value" :alias="'Valor'"></number-input>
                </div>
                <div class="col-md-2">
                    <number-input :alias="'Desconto'" v-model="form.price.value"></number-input>
                </div>
            </div>
            <div class="row justify-content-end">

                <div class="col-md-4">
                    <select-input v-model="form.csosn.value" :alias="'CSOSN'" :options="form.csosn.options"></select-input>
                </div>

                <div class="col-md-2">
                    <text-input v-model="form.cfop.value" :alias="'CFOP'"></text-input>
                </div>

                <div class="col-md-2">
                    <text-input :alias="'CEST'" v-model="form.cest.value"></text-input>
                </div>

                <div class="col-md-2">
                    <text-input v-model="form.ncm.value" :alias="'NCM'"></text-input>
                </div>
                <div class="col-md-2">
                    <number-input :value="total" :disabled="true" :alias="'Total'"></number-input>
                </div>

                <div class="col-md-2 ">
                    <div class="form-group">
                        <label class="control-label">&nbsp;</label>
                        <br />
                        <button class="btn btn-block btn-sm btn-success" @click="comfirmProduct">
                            <i class="fas fa-arrow-down"></i>
                            Adicionar
                        </button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <template v-if="hasProducts">
                        <div class="table-responsive">
                            <table class="table table-hover customTable">
                                <tr>
                                    <th style="width:25%">Produto</th>
                                    <th style="width:8%" class="text-center">Unidade</th>
                                    <th style="width:8%" class="text-center">CFOP</th>
                                    <th style="width:8%" class="text-center">CEST</th>
                                    <th style="width:8%" class="text-center">NCM</th>
                                    <th style="width:8%" class="text-center">CSOSN</th>
                                    <th style="width:8%" class="text-center">Quantidade</th>
                                    <th style="width:8%" class="text-center">Preço</th>
                                    <th style="width:8%" class="text-center">Total</th>
                                    <th style="width:0%"></th>
                                </tr>
                                <tbody>
                                    <tr v-for="(row, index) in products" :key="row.index">
                                        <td style="width:25%">{{ row.description }}</td>
                                        <td style="width:8%" class="text-center">{{ row.unit}}</td>
                                        <td style="width:8%" class="text-center">{{ row.cfop}}</td>
                                        <td style="width:8%" class="text-center">{{ row.cest}}</td>
                                        <td style="width:8%" class="text-center">{{ row.ncm}}</td>
                                        <td style="width:8%" class="text-center">{{ row.csosn}}</td>
                                        <td style="width:8%" class="text-center">{{ row.quantity | decimal }}</td>
                                        <td style="width:8%" class="text-center">{{ row.price | decimal }}</td>
                                        <td style="width:8%" class="text-center">{{ row.quantity * row.price | decimal}}</td>
                                        <td style="width:0%" class="text-center">
                                            <button class="btn btn btn-light" @click="setProductUpdate(index)">
                                                <i class="text-info fas fa-pen" />
                                            </button>
                                            <button style="margin-left:10px" class="btn btn btn-light" @click="deleteProduct(index)">
                                                <i class="text-info fas fa-trash" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </template>

                    <template v-else>
                        <span class="text-info">Utilize o formulario acima para adicionar produtos...</span>
                        <br />
                        <br />
                    </template>
                </div>
            </div>
        </div>
    </b-card>
</div>
</template>

<script>
import Form from "./../../mixins/Form.js";
import Filters from "./../../mixins/Filters.js";

export default {
    props: {
        value: {}
    },

    data: function () {
        return {
            updateIndex: null,

            products: [],

            //productsUpdatePointer : null,

            form: new Form({
                id: {
                    alias: "Produto",
                    validate: {
                        required: true
                    }
                },

                description: {
                    value: null
                },

                quantity: {
                    value: 1
                },

                unit: {},

                ncm: {},

                cest: {},

                csosn: {
                    options: {
                        "": "",
                        101: "  101 | Tributada pelo Simples Nacional com permissão de crédito",
                        102: "  102 | Tributada pelo Simples Nacional sem permissão de crédito",
                        103: "  103 | Isenção do ICMS no Simples Nacional para faixa de receita bruta",
                        201: "  201 | Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária",
                        202: "  202 | Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária",
                        203: "  203 | Isenção do ICMS no Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária",
                        300: "  300 | Imune",
                        400: "  400 | Não tributada pelo Simples Nacional",
                        500: "  500 | ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação",
                        900: "  900 | Outros"
                    }
                },

                cfop: {
                    value: null
                },

                table_price: {
                    value: 0
                },

                price: {
                    value: 0
                }
            }),

            searchProductResults: {}
        };
    },

    mounted() {
        this.products = this.value;

        //this.products.push(new Form(JSON.parse(JSON.stringify(this.itemFormData))))

        //this.products.push(new Form(JSON.parse(JSON.stringify(this.itemFormData))))

        // axios.post('api/product/select')
        //   .then(response => {

        //     this.people = response.data

        //     this.makeToast()

        //   })
        //   .catch(error => {

        //     this.error = error

        //   })
    },

    watch: {
        value(newValue, oldValue) {
            this.products = newValue;
        }
    },

    computed: {
        total() {
            return this.form.quantity.value * this.form.price.value;
        },

        hasProducts() {
            return this.products.length > 0;
        },

        insertState() {
            return this.updateIndex == null;
        }
    },

    methods: {
        // make a search for search input
        searchProduct(text) {
            this.productIsLoading = true
            axios.post(process.env.BASE_URL + 'api/searchproductorder/select', {
                    description: text.text
                })
                .then(response => {
                    this.searchProductResults = response.data
                    this.productIsLoading = false
                })
                .catch(error => {
                    this.productIsLoading = false
                    this.error = error
                })
        },

        // set value for searchInput
        setProductValue(product) {
            this.form.setValues(product);

            this.form.id.value = product.id

            this.form.description.value = product.description

            this.form.table_price.value = product.price

            this.form.price.value = product.price

            this.form.cfop.value = product.cfop

            this.form.ncm.value = product.ncm

            this.form.cest.value = product.cest

        },

        comfirmProduct() {
            if (!this.form.isValid()) {
                return;
            }

            if (this.insertState) {
                this.insertProduct();
            } else {
                this.updateProduct();
            }

            this.$refs.searchProductInput.setFocus();
        },

        insertProduct() {
            this.products.push(this.form.getValues());

            this.$emit("input", this.products);

            this.resetForm();
        },

        setProductUpdate(index) {
            this.resetForm();

            this.updateIndex = index;

            this.form.setValues(this.products[index]);

            this.$refs.searchProductInput.setFocus();
        },

        // remove product from list
        deleteProduct(index) {

            this.$delete(this.products, index);
        },

        updateProduct() {
            /*
             * Abaixo um erro comum *
              https://br.vuejs.org/v2/guide/list.html#Limitacoes
             */

            // Não é reativo
            ////this.products[this.updateIndex] = this.form.getValues()

            // É Reativo
            this.$set(this.products, this.updateIndex, this.form.getValues());

            this.$emit("input", this.products);

            this.resetForm();
        },

        resetForm() {
            this.form.reset();

            this.updateIndex = null;

            this.form.quantity.value = 1;
        }
    }
};
</script>

<style>
/*.orderProductInputs {

    margin-bottom: 0px;

  }

  .orderProductCell {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }*/
</style>
